import React from 'react';
import '../App.css';

export default function ControlPanel({
  userColor,
  setUserColor,
  active,
  setActive,
  handleSave,
  handleReset,
  source,
  setSource,
  toggleRating,
  ratings,
  toggleSpeed,
  speeds
}) {
  const handleColorChange = (color) => {
    setUserColor(color);
  };

  const smallBottomMargin = {
    marginBottom: '0.5rem'
  }

  const mediumBottomMargin = {
    marginBottom: '1rem'
  }

  return (
    <div className="control-panel">
      <div style={mediumBottomMargin}>
        <button onClick={() => setActive(!active)} className={active ? 'selected' : ''}>
          {active ? "Pause" : "Play"}
        </button>
      </div>

      <div style={{ marginBottom: '0.5rem' }}>
        <button onClick={handleSave}>Save</button>
        <button onClick={handleReset}>Reset</button>
      </div>

        <div style={{ marginBottom: '0.5rem' }}>
        <button
            onClick={() => handleColorChange("w")}
            className={userColor === "w" ? "selected" : ""}
        >
            White
        </button>
        <button
            onClick={() => handleColorChange("b")}
            className={userColor === "b" ? "selected" : ""}
        >
            Black
        </button>
        </div>

      <div style={{ margin: '1rem 0' }}>
        <strong>Source:</strong><br />
        {["lichess", "masters"].map(opt => (
          <button
            key={opt}
            onClick={() => setSource(opt)}
            className={source === opt ? "selected" : ""}
            style={{ marginRight: '0.5rem' }}
          >
            {opt}
          </button>
        ))}
      </div>

      {source !== "masters" && (
        <>
          <div>
            <strong>Ratings:</strong><br />
            {[1600, 1800, 2000, 2200, 2500].map(r => (
              <button
                key={r}
                onClick={() => toggleRating(String(r))}
                className={ratings.includes(String(r)) ? "selected" : ""}
              >
                {r}
              </button>
            ))}
          </div>

          <div style={{ marginTop: '0.5rem' }}>
            <strong>Time Controls:</strong><br />
            {["blitz", "rapid", "classical"].map(tc => (
              <button
                key={tc}
                onClick={() => toggleSpeed(tc)}
                className={speeds.includes(tc) ? "selected" : ""}
              >
                {tc}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
